$(() => {
  $(document).ready(function() {
    $(".footer-collapse").on("show.bs.collapse", function () {
      $(this).parent().find("i.fa-plus").removeClass("fa-plus").addClass("fa-times");
    })

    $(".footer-collapse").on('hide.bs.collapse', function () {
      $(this).parent().find("i.fa-times").removeClass("fa-times").addClass("fa-plus");
    })
  })
})